export const GENERATE_VERIFY_EMAIL_OTP_REQUEST = 'GENERATE_VERIFY_EMAIL_OTP_REQUEST'
export const GENERATE_VERIFY_EMAIL_OTP_SUCCESS = 'GENERATE_VERIFY_EMAIL_OTP_SUCCESS'
export const GENERATE_VERIFY_EMAIL_OTP_FAILED = 'GENERATE_VERIFY_EMAIL_OTP_FAILED'
